import { createContext, Dispatch, SetStateAction, use } from 'react';

import { PageTitlesTranslation } from '@/assets/locales/pageTitles/pageTitles.translation.en.ts';
import { emptyFunction } from '@/utils/emptyFunction.utils';

export enum LayoutStates {
  HIDDEN = 'HIDDEN',
  VISIBLE = 'VISIBLE',
}

export interface PageContextProps {
  handleLayoutStateChange: () => void;
  layoutState: LayoutStates;
  pageDetails: PageDetailsModel;
  rightSideBarWidth: number;
  setLayoutState: Dispatch<SetStateAction<LayoutStates>>;
  setPageDetails: Dispatch<SetStateAction<PageDetailsModel>>;
}

export type PageDetailsModel = {
  backButtonId?: keyof PageTitlesTranslation;
  backButtonUrl?: string;
  titleId: keyof PageTitlesTranslation;
};

export const PageContextDefaultValues: PageContextProps = {
  handleLayoutStateChange: emptyFunction,
  layoutState: LayoutStates.HIDDEN,
  pageDetails: { titleId: 'processes' },
  rightSideBarWidth: 0,
  setLayoutState: emptyFunction,
  setPageDetails: emptyFunction,
};
export const PageContext = createContext<PageContextProps>(PageContextDefaultValues);

export const usePageContext = (): PageContextProps => {
  return use<PageContextProps>(PageContext);
};
